import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-stats-card",
  templateUrl: "./stats-card.component.html",
  styleUrl: "./stats-card.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatsCardComponent {
  @Input() icon: string = "";
  @Input() label: string = "";
  @Input() value: string | number = "";
  @Input() items: Array<{ label: string; value: string | number }> = [];
  @Input() size: "small" | "large" = "small";
  @Input() tooltip: string = "";
  @Input() trend: "up" | "down" | null = null;
  @Input() trendPercentage: number | null = null;
}
